var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__main",class:{ active: _vm.value, [_vm.position]: true }},[_vm._t("default",null,{"close":_vm.close})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }